<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <!-- 页面头部 -->
    <div>
      <div
        class="page-card__header"
      >
        <el-row>
          <el-col :span="4">
            展商登记（共{{ aSum }}）
          </el-col>
          <el-col :span="6" :offset="14">
            <el-input v-model="input">
              <el-button slot="append" icon="el-icon-search" @click="serach"></el-button>
            </el-input>
          </el-col>
        </el-row>

      </div>
    </div>
    <!-- 数据表格 -->
    <el-table :data="tableData" style="width: 100%; padding: 0 20px">
      <el-table-column label="ID" prop="id"></el-table-column>
      <el-table-column prop="wx_user_detail.avatarurl" label="微信头像">
        <template slot-scope="scope">
          <el-image
            :src="logourl + scope.row.wx_user_detail.avatarurl"
            style="width: 30px"
          >
            <div slot="error">
              <i class="el-icon-picture-outline" style="font-size: 30px"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名字"></el-table-column>
      <el-table-column prop="position" label="职务"></el-table-column>
      <el-table-column prop="phone_number" label="手机号"></el-table-column>
      <el-table-column prop="company" label="公司名">
      </el-table-column>
      <el-table-column prop="booth" label="展位号">
      </el-table-column>
      <el-table-column prop="ad" label="广告服务"></el-table-column>
      <el-table-column prop="create_time" label="加入时间"></el-table-column>
      <!-- 操作列 -->
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="action-btn--danger"
            @click="deleteClick(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import api from "../../utils/api";

  export default {
    data() {
      return {
        tableData: [],
        input:'',
        logourl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/avatar/",
        //分页
        // 总条目数 total
        aSum: 0,
        // 当前页数 currenr_page
        currentPage: 1,
        // 总页数 num_pages
        pageCount: 1,
        // 每页显示条目数 pagesize
        pagesize: 10,
      };
    },
    mounted() {
      this.hitListData();
    },
    methods: {
      // 获取展商登记列表数据
      hitListData() {
        let url = this.baseUrl + "/admin/exhibitors/?ordering=-create_time";
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      // 搜索参展人员
      serach() {
        let url = this.baseUrl + "/admin/exhibitors/?ordering=-create_time&search=" + this.input;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      // 分页切换
      handleCurrentChange(val) {
        let url = this.baseUrl + "/admin/exhibitors/?ordering=-create_time&page=" + val+'&search='+this.input;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      // 删除参展人员
      deleteClick(row) {
        this.$confirm("将删除此条信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let id = row.id;
          let url = this.baseUrl + "/admin/exhibitors/" + id + "/";
          api.deleteData(url).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.hitListData();
          });
        });
      },
    },
  };
</script>

<style scoped>

  .el-input-group__append button.el-button {
    background-color: #42b983;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/ex_user.vue